define("TavanoTeam.ContactUsForm.Router",
    ["ContactUsForm.View"],

    function(ContactUsFormView) {
    "use strict";

    var Router = Backbone.Router.extend({
        routes: {
            "contact-us" : "contactUsForm"
        },

        initialize: function(options) {
            this.application = options.application;
        },
        
        contactUsForm: function() {
            var view = new ContactUsFormView({
                application: this.application
            });
            view.showContent();
        }
    });

    return Router;

});
